import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import Application from './Application'
import { ContextProvider } from './utility/ContextProvider'

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <Application />
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
